import type { EasyClaimBackendConfiguration } from '../AppConfiguration';

/**
 * Runtime configuration for the easyclaim.app module (experimental performance enhancer).
 *
 * Reuses the same `easyClaimBackend` configuration (`basePath`/`apiKey`) already resolved
 * from the runtime `/config.json` (see `src/index.tsx`) instead of introducing a separate
 * build-time env mechanism. `configureEasyClaimEnv` must be called once during app bootstrap,
 * right after `appConfiguration` is fetched.
 */
let config: EasyClaimBackendConfiguration | undefined;

export function configureEasyClaimEnv(easyClaimBackend: EasyClaimBackendConfiguration): void {
	config = easyClaimBackend;
}

/** Returns the resolved config. Throws if {@link configureEasyClaimEnv} hasn't run yet. */
export function getEasyClaimEnv(): EasyClaimBackendConfiguration {
	if (!config) {
		throw new Error(
			'Config is not configured: call configureEasyClaimEnv(appConfiguration.easyClaimBackend) during app bootstrap.'
		);
	}

	return config;
}
